<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Order Penjualan</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Penjualan / Order Penjualan</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          type="button"
          icon="pi pi-refresh"
          label="Reset"
          class="p-button-outlined"
          @click="clearFilter()"
        />
      </div>
      <fx-table
        ref="table"
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        :filters="filters"
        @request="onRequestData"
        @sort="onSort($event)"
      >
        <template #columns>
          <Column style="min-width: 3rem; flex: initial" header="" expander>
          </Column>
          <Column
            field="sl_no"
            header="NO Order"
            style="min-width: 16rem"
            :showFilterMenu="false"
            sortable
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="sl_at"
            header="Tgl Order"
            style="min-width: 12rem"
            :showFilterMenu="false"
          >
            <template #body="{ data }">
              {{ formatDate(data.sl_at) }}
            </template>
            <template #filter="{ filterModel, filterCallback }">
              <CalendarFilter
                ref="calendarFilter"
                v-model="filterModel.value"
                showButtonBar
                numberOfMonths="2"
                @select="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="branch"
            header="Branch"
            style="min-width: 12rem"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="cashreg"
            header="Cashreg"
            style="min-width: 12rem"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="pos_no"
            header="No. Transaksi"
            style="min-width: 12rem"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="dpp"
            header="GRAND TOTAL"
            style="min-width: 12rem"
            :showFilterMenu="false"
          >
            <template #body="slotProps">
              {{ formatCurrency((slotProps.data.dpp || 0) - (slotProps.data.return_value || 0)) }}
            </template>
            <template #filter="{ filterModel, filterCallback }">
              <InputNumber
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder=""
                locale="id-ID"
                :min="0"
                :maxFractionDigits="2"
                :minFractionDigits="0"
                @input="filterModel.value = $event.value"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="created_by"
            header="Kasir"
            style="min-width: 12rem"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="src"
            header="Source"
            style="min-width: 12rem"
            :showFilterMenu="false"
            sortable
          >
            <template #body="{ data }">
              {{ data.src }}
            </template>
            <template #filter="{ filterModel, filterCallback }">
              <Dropdown
                v-model="filterModel.value"
                @change="filterCallback()"
                :options="list_source"
                optionValue="value"
                optionLabel="label"
                class="p-column-filter"
              >
              </Dropdown>
            </template>
          </Column>
          <Column style="flex-grow: 1; justify-content: flex-end">
            <template #body="{ data }">
              <Button
                type="button"
                icon="pi pi-print"
                class="p-button-outlined p-button-secondary p-button-text mr-2"
                @click="onPrint(data)"
                :disabled="data.status != 'done'"
              />
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-outlined p-button-secondary p-button-text mr-2"
                @click="onEditData(data)"
              />
            </template>
          </Column>
        </template>
      </fx-table>
    </div>
    <Dialog
      :header="'Edit Pembayaran'"
      v-model:visible="dialog"
      class="p-overflow-hidden"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '45vw' }"
      modal
      maximizable
    >
      <form-sales
        :item="form"
        :loading="isLoadingSave"
        :list-payment="list_payment"
        @save="onSaveData"
        @close="dialog = false"
      />
    </Dialog>
    <Dialog
      :header="pdfTitle"
      v-model:visible="dialogViewer"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '90vw' }"
      :modal="true"
    >
      <div>
        <embed
          :src="pdfSource"
          type="application/pdf"
          width="100%"
          height="600px"
        />
      </div>
      <template #footer>
        <Button
          type="button"
          label="Download"
          icon="pi pi-download"
          class="p-button-text mr-2"
          @click="onDownloadPdf"
        />
        <Button
          type="button"
          label="Print"
          icon="pi pi-print"
          @click="onPrintPdf"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import SupplierService from '@/services/SupplierService'
import SaleingOrderService from '@/services/SaleingOrderService'
import PaymentService from '@/services/PaymentService'
import FormSales from '@/components/penjualan/FormSales'
import FxTable from '@/components/penjualan/GridSo'
import CalendarFilter from '@/components/CalendarFilter.vue'
import errorHandler from '@/helpers/error-handler'
import Hotkey from '@/components/Hotkey'
import { FilterMatchMode } from 'primevue/api'
import { formatCurrency, formatDate } from '@/helpers/index'
import { saveAs } from 'file-saver'

export default {
  name: 'SaleingOrder',
  components: {
    FormSales,
    CalendarFilter,
    FxTable,
    Hotkey,
  },
  data() {
    return {
      dialog: false,
      supplierService: null,
      saleingOrderService: null,
      paymentService: null,
      isLoading: false,
      isLoadingSave: false,
      items: [],
      form: {},
      PurchaseOrder: [],
      list_supplier: [],
      list_payment: [],
      list_source: [
        { value: 'jpos-lama', label: 'JPOS-lama', level: 0 },
        { value: 'jpos-baru', label: 'JPOS-baru', level: 1 },
      ],
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: '-sl_at',
        sortOrder: '1',
        filters: null,
      },
      filters: {
        sl_no: { value: null, matchMode: FilterMatchMode.EQUALS },
        sl_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
        branch: { value: null, matchMode: FilterMatchMode.EQUALS },
        cashreg: { value: null, matchMode: FilterMatchMode.EQUALS },
        pos_no: { value: null, matchMode: FilterMatchMode.EQUALS },
        dpp: { value: null, matchMode: FilterMatchMode.CONTAINS },
        src: { value: null, matchMode: FilterMatchMode.EQUALS },
        created_by: { value: null, matchMode: FilterMatchMode.EQUALS },
      },
      pdfSource: '',
      pdfFilename: '',
      pdfTitle: 'PDF Viewer ',
      dialogViewer: false,
    }
  },
  watch: {
    'options.filters'(value) {
      // custom Forcibly delete calendar data because it can't be deleted by default
      if (!value.sl_at.value) {
        this.$refs.calendarFilter.clearValueOnly()
      }
    },
  },
  created() {
    this.supplierService = new SupplierService()
    this.saleingOrderService = new SaleingOrderService()
    this.paymentService = new PaymentService()
  },
  async mounted() {
    this.loadData()
    this.supplierService
      .get()
      .then((res) => {
        this.list_supplier = res.data
      })
      .catch((err) => {
        errorHandler(err, 'Data Supplier', this)
      })
      .finally(() => (this.isLoading = false))

    this.paymentService.get().then((res) => {
      this.list_payment = res.data.map((p) => ({
        ...p,
        kode: p.kode.toUpperCase(), // value uppercase
        name: p.kode.toUpperCase(), // tampil uppercase
      }))
    })
  },
  methods: {
    clearFilter() {
      if (this.$refs.calendarFilter != undefined) {
        this.$refs.calendarFilter.clearValueOnly()
      }
      if (this.$refs.table != undefined) {
        this.$refs.table.initFilters()
      }
    },
    formatCurrency(val) {
      return formatCurrency(val, 0, 0)
    },
    formatDate(value) {
      return formatDate(value)
    },
    onRequestData(e) {
      this.options = e
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      this.saleingOrderService
        .paginate(page, perPage, sortField, sortOrder, filters)
        .then((res) => {
          this.items = res.data
          this.totalRecords = res.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data Order Penjualan', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onSort(e) {
      this.options.value = e
      this.loadData()
    },
    onEditData(data) {
      this.form = Object.assign({}, data)
      this.form = { ...this.form }
      this.dialog = true
    },
    onSaveData(data) {
      this.isLoadingSave = true
      const payload = {
        sl_no: data.sl_no,
        paymentMethod1: data.member_1,
        paymentNominal1: data.payment_1,
        paymentMethod2: data.member_2,
        paymentNominal2: data.payment_2,
      }
      this.saleingOrderService
        .update(payload)
        .then((res) => {
          if (res.data) {
            this.loadData()
            this.$toast.add({
              severity: 'success',
              summary: 'Data Penjualan',
              detail: 'Data berhasil disimpan.',
              life: 3000,
            })
            this.dialog = false
          }
        })
        .catch((err) => {
          errorHandler(err, 'Data Penjualan', this)
        })
        .finally(() => (this.isLoadingSave = false))
    },
    onPrintData(data) {
      this.saleingOrderService
        .print(data.id)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'SalesOrder.pdf')
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          errorHandler(err, 'Print Order Penjualan', this)
        })
    },
    onDownloadPdf() {
      saveAs(this.pdfSource, this.pdfFilename)
    },
    onPrintPdf() {
      const iframe = document.createElement('iframe')
      iframe.src = this.pdfSource
      iframe.style.display = 'none'
      document.body.appendChild(iframe)

      // Use onload to make pdf preview work on firefox
      iframe.onload = () => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }
    },
    onPrint(data) {
      this.saleingOrderService
        .print(data.id)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' })
          const pdfUrl = URL.createObjectURL(blob)
          this.pdfSource = pdfUrl + '#toolbar=0'
          this.pdfFilename = 'sales-order.pdf'
          this.pdfTitle = 'PDF Viewer (' + this.pdfFilename + ')'
          this.dialogViewer = true
        })
        .catch((err) => {
          errorHandler(err, 'Print Order Penjualan', this)
        })
    },

    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.$router.push({ name: 'PurchaseOrderAdd' })
      }
    },
    /* onToggle(value) {
      this.selectedColumns = this.columns.filter((col) => value.includes(col))
    }, */
  },
}
</script>
